import React from 'react';
import { Segmented } from 'antd';
import { RuleStatusFilterValue } from './getRuleStatus';

interface RuleStatusFilterProps {
  value?: RuleStatusFilterValue;
  onChange?: (value: RuleStatusFilterValue) => void;
}

const OPTIONS = [
  { label: 'Active & Scheduled', value: 'active_scheduled' },
  { label: 'All', value: 'all' },
  { label: 'Expired', value: 'expired' },
];

const RuleStatusFilter = ({ value = 'active_scheduled', onChange }: RuleStatusFilterProps) => (
  <Segmented
    size="small"
    options={OPTIONS}
    value={value}
    onChange={(val) => onChange?.(val as RuleStatusFilterValue)}
  />
);

export default RuleStatusFilter;
